import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getBrandThemeClass } from '../branding/brandings';

export const BodyClassController = () => {
    const location = useLocation();
    const themeClass = getBrandThemeClass();

    useEffect(() => {
        const rootElement = document.getElementById('root');

        if (rootElement) {
            document.body.classList.remove(
                'template-base',
                'template-error',
                'theme-tuid',
                'theme-dnit',
                'theme-trident'
            );
            rootElement.classList.remove('route-login-root');
            document.body.classList.add(themeClass);

            switch (location.pathname) {
                case '/pin':
                case '/consent':
                case '/select-certificate':
                    rootElement.classList.add('route-login-root');
                    break;
                default:
                    document.body.classList.add('template-base');
                    break;
            }
        }
    }, [location.pathname, themeClass]);

    return null;
};
